export class AppConstants {
	public static isExiting = true;
	public static readonly VERSION_NUM = "1.11.10";
	public static readonly DELIMITER1: string = ",";
	public static readonly DELIMITER2: string = ";";
	public static readonly LANGUAGE: string = "language";
	public static readonly PRESENTATION_MODE: string = "presentation_mode";
	public static readonly MODULE_ID: string = "module_id";
	public static readonly SCENE_ID: string = "scene_id";
	public static readonly PAGE_ID: string = "page_id";
	public static readonly MAIN_MENU: string = "main_menu";
	public static readonly DEMO_MODE: string = "demo";
	public static readonly RUN_MODE: string = "run";
	public static readonly NOT_ATTEMTED: string = "n";
	public static readonly INCOMPLETE: string = "i";
	public static readonly COMPLETE: string = "c";
	public static readonly SILENT: string = "low";
	public static readonly AUDIO: string = "medium";
	public static readonly VIDEO: string = "high";
	public static readonly CORRECT_AUDIO_PATH: string =
		"./assets/audio/correct.mp3";
	public static readonly INCORRECT_AUDIO_PATH: string =
		"./assets/audio/incorrect.mp3";
	public static readonly SETTING_XML_PATH: string = "/settings_rcp.xml";
	public static readonly PLATFORM: string = "platform";

	public static readonly ADAPTIVE: string = "adaptive";
	public static readonly NONADAPTIVE: string = "nonadaptive";
	public static readonly NON_ADAPTIVE: string = "non-adaptive";
	public static readonly SCENARIO: string = "scenario";
	public static readonly END: string = "end";

	public static readonly US_ENGLISH: string = "english";
	public static readonly KOREAN: string = "korean";
	public static readonly CZECH: string = "czech";
	public static readonly POLISH: string = "polish";
	public static readonly VIETNAMESE: string = "vietnamese";
	public static readonly ROMANIAN: string = "romanian";
	public static readonly SLOVAK: string = "slovak";
	public static readonly HUNGARIAN: string = "hungarian";
	public static readonly SLOVENIAN: string = "slovenian";
	public static readonly TURKISH: string = "turkish";
	public static readonly BOSNIAN: string = "bosnian";
	public static readonly CROATIAN: string = "croatian";
  public static readonly NAVEX_URL: string = "http://navexone.com/";
}

export class KeyPressConstants {
    public static readonly KeyPressCodes = ["Space","Enter","ArrowLeft","ArrowRight","ArrowUp","ArrowDown","Tab"];
    public static readonly SPACE = "Space";
    public static readonly ENTER = "Enter"; 
    public static readonly ARROWLEFT = "ArrowLeft"; 
    public static readonly ARROWRIGHT = "ArrowRight"; 
    public static readonly ARROWUP = "ArrowUp"; 
    public static readonly ARROWDOWN = "ArrowDown"; 
    public static readonly TAB = "Tab"; 
    public static readonly ESCAPE = "Escape"; 
}
